
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.955 3.663c.414-.96.875-2.035 1.043-2.46a.49.49 0 01.244.051c.276.12.44.357.44.558V4.04a.6.6 0 00.6.6h3.046c.02 0 .134.025.264.226.125.194.164.406.146.52l-.408 2.447v.001l-.001.006c-.18 1.08-.361 2.164-.41 2.465-.015.088-.083.208-.252.32a1.081 1.081 0 01-.57.174h-4.89V5.867l-.001-.056v-.42l.016-.036.176-.406.557-1.286zm-1.75 1.02l.093-.212.556-1.283c.42-.976.875-2.039 1.032-2.435.16-.406.49-.646.857-.723.342-.072.69-.002.981.125.563.247 1.157.837 1.157 1.657V3.44h2.447c.595 0 1.03.402 1.272.775.245.38.4.89.322 1.365l-.407 2.444v.002l-.003.012-.41 2.461c-.083.511-.415.89-.774 1.127a2.28 2.28 0 01-1.231.373H2.744a1.8 1.8 0 01-1.8-1.8V6.467a1.8 1.8 0 011.8-1.8h1.263c.068 0 .134.006.198.017zm-.199 1.184H2.744a.6.6 0 00-.6.6V10.2a.6.6 0 00.6.6h1.262V5.867z","fill":"#060"}})])
          )
        }
      }
    